// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__container--BkUWr{position:fixed;bottom:15px;left:15px;text-align:center;border:1px solid;border-radius:15px;padding:10px;color:dimgray;background-color:#f7f7f7;font-size:13px;-webkit-box-shadow:10px 17px 40px -16px #c2c2c2;-moz-box-shadow:10px 17px 40px -16px #c2c2c2;box-shadow:10px 17px 40px -16px #c2c2c2}.index-module__notice--nD3fn{padding-bottom:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container--BkUWr`,
	"notice": `index-module__notice--nD3fn`
};
export default ___CSS_LOADER_EXPORT___;
